import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PartnersPage from "../pages/PartnersPage";
import PartnerDetailsPage from "../pages/PartnerDetailsPage";
import PurchaseHistoryPage from "../pages/PurchaseHistoryPage";

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
<Routes>
  <Route path="/" element={<PartnersPage />} />
  <Route path="/partner/:id" element={<PartnerDetailsPage />} />
  <Route path="/partner/:id/history" element={<PurchaseHistoryPage />} />
</Routes>
    </BrowserRouter>
  );
};

export default AppRouter;